import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MaterialLink from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import * as firebase from 'firebase';
import {Link} from "react-router-dom";
import { useHistory } from "react-router-dom";
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputAdornment from '@material-ui/core/InputAdornment';
import FilledInput from '@material-ui/core/FilledInput';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <MaterialLink color="inherit" href="https://material-ui.com/">
        Your Website
      </MaterialLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Seek(props) {
  const classes = useStyles();
  const [companyName, setCompanyName] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [website, setWebsite] = useState('');
  const [team, setTeam] = useState('');
  const [industry, setIndustry] = useState('');
  const [fundingGoal, setFundingGoal] = useState(0);
  const [equity, setEquity] = useState(0);

  const currency = "SGD";

  const history = useHistory();

  const onSubmit = (event) => {
    event.preventDefault();
    console.log(`${companyName} ${location} ${team} ${industry}`);
    firebase.database().ref("listings/" + firebase.auth().currentUser.uid).set(
      {
        companyName: companyName,
        description: description,
        location: location,
        website: website,
        team: team,
        industry: industry,
        fundingGoal: fundingGoal,
        equity: equity
      }
    );
    history.push("/dashboard");
  }

  if(!firebase.apps.length || !firebase.auth().currentUser){
    history.replace("/login");
  }

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Company Details
        </Typography>
        <form className={classes.form} onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="companyName"
                variant="outlined"
                required
                fullWidth
                id="companyName"
                label="Company Name"
                autoFocus
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="description"
                label="Description"
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                multiline
                rows="4"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="location"
                label="Location"
                name="location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="website"
                label="Website"
                id="website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="Team"
                label="Team Description"
                name="team"
                value={team}
                onChange={(e) => setTeam(e.target.value)}
                multiline
                rows="2"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth required>
                <InputLabel htmlFor="outlined-age-native-simple">
                  Industry
                </InputLabel>
                <Select
                  native
                  value={industry}
                  onChange={(e)=>setIndustry(e.target.value)}
                  // labelWidth={labelWidth}
                  inputProps={{
                    name: 'industry',
                    id: 'outlined-currency-native-simple',
                  }}
                >
                  <option value="" disabled/>
                  <option value={"Finance"}>Finance</option>
                  <option value={"Social Enterprise"}>Social Enterprise</option>
                  <option value={"Sustainability"}>Sustainability</option>
                  <option value={"e-Commerce"}>e-Commerce</option>
                  <option value={"Healtcare"}>Healthcare</option>
                  <option value={"Transport"}>Transport</option>
                  <option value={"Retail"}>Retail</option>
                  <option value={"Education"}>Education</option>
                  <option value={"Others"}>Others</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth className={classes.margin} variant="outlined" required>
                <InputLabel htmlFor="filled-adornment-amount">Funding Goal</InputLabel>
                <FilledInput
                  id="filled-adornment-amount"
                  value={fundingGoal}
                  onChange={(e) => setFundingGoal(e.target.value)}
                  startAdornment={<InputAdornment position="start">{currency}</InputAdornment>}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth className={classes.margin} variant="outlined" required>
                <InputLabel htmlFor="filled-adornment-amount">Equity</InputLabel>
                <FilledInput
                  id="filled-adornment-amount"
                  value={equity}
                  onChange={(e) => setEquity(e.target.value)}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                />
              </FormControl>
            </Grid>
            {/* <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                label="I want to receive inspiration, marketing promotions and updates via email."
              />
            </Grid> */}
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Submit
          </Button>
          {/* <Grid container justify="flex-end">
            <Grid item>
              <MaterialLink variant="body2">
                <Link to="/login">Already have an account? Sign in</Link>
              </MaterialLink>
            </Grid>
          </Grid> */}
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}


// WEBPACK FOOTER //
// ./src/components/seek.js